
import { cartPromoOffers, promoCodeError } from '@/utils/promoOffers'
import { isPercentage } from '@/utils/welcomeOffer'

export default {
  name: 'CartPromoCodeForm',
  props: {
    order: Object,
  },
  data() {
    return {
      form: { promo_code: '' },
      isOpen: false,
      codes: [],
      codesLoaded: false,
      applying: null,
      error: null,
      conditionsCode: null,
      conditionsModalId: 'cartPromoOfferConditionsModal',
    }
  },
  computed: {
    showsDiscountHt() {
      return (
        (this.$auth.loggedIn && !this.$store.getters.show_vat) ||
        this.$store.getters.is_pro
      )
    },
    isRemovable() {
      return this.order.order_global_status?.identifier === 'not_ordered'
    },
    offers() {
      return cartPromoOffers({
        codes: this.codes,
        order: this.order,
        isPartner: Boolean(this.$store.getters.is_pro_plus),
      })
    },
  },
  watch: {
    order() {
      this.applying = null
    },
    'order.total_code_ttc'(discount) {
      if (!discount) return
      this.form.promo_code = ''
      this.error = null
    },
  },
  methods: {
    isPercentage,

    open() {
      this.isOpen = true
      this.$nextTick(() => this.$refs.promoCodeInput?.focus())
      this.loadCodes()
    },

    async loadCodes() {
      if (this.codesLoaded) return
      this.codesLoaded = true
      try {
        const response = await this.$codeService.fetch({
          'filter[featured]': true,
          'filter[inDateRange]': true,
          include: 'code_mode,account_type,selected_brands,excluded_brands',
        })
        this.codes = response.data || []
      } catch {
        this.codes = []
      }
    },

    offerDetails({ code, missing }) {
      const details = []
      if (missing > 0) {
        details.push({
          text: this.$t('components.cartPromoCodeForm.missingForOffer', {
            amount: this.$options.filters.priceFormat(missing),
          }),
          strong: true,
        })
      } else if (code.minimum_order_value > 0) {
        details.push({
          text: this.$t('pages.codesPromo.index.minimumCartShort', {
            amount: code.minimum_order_value,
          }),
        })
      }
      if (code.date_to) {
        details.push({
          text: `${this.$t(
            'pages.codesPromo.index.expiresOn'
          )} ${this.formatDate(code.date_to)}`,
        })
      }

      return details
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString(this.$i18n.locale, {
        day: '2-digit',
        month: '2-digit',
      })
    },

    showConditions(code) {
      this.conditionsCode = code
      this.$nextTick(() => this.$bvModal.show(this.conditionsModalId))
    },

    formatPromoCode(value) {
      const formatted = value.toUpperCase().replace(/[^A-Z0-9]/g, '')
      this.form.promo_code = formatted
      this.error = null
    },

    deletePromoCode() {
      this.$orderService.applyCode(this.order.id, { code: null }).then(() => {
        this.$emit('update-cart')
      })
    },

    onSubmit() {
      this.apply(this.form.promo_code, 'form')
    },

    async apply(code, source) {
      if (!code || this.applying) return
      this.applying = source
      try {
        await this.$orderService.applyCode(this.order.id, { code })
        this.error = null
        this.$emit('update-cart')
      } catch (error) {
        const { key, text } = promoCodeError(error)
        this.applying = null
        this.error = text || this.$t(key)
        if (this.form.promo_code !== code) this.form.promo_code = code
        this.$nextTick(() => this.$refs.promoCodeInput?.focus())
      }
    },
  },
}
